/**
 * This file is part of Magestore POS Open Source.
 *
 * Magestore POS Open Source is free software: you can redistribute it
 * and/or modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation, either version 3
 * of the License, or (at your option) any later version.
 *
 * Magestore POS Open Source is distributed in the hope that it will
 * be useful, but WITHOUT ANY WARRANTY; without even the implied warranty
 * of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along
 * with Magestore POS Open Source. If not, see <https://www.gnu.org/licenses/>
 */ 
import {WeeeDataService} from "./WeeeDataService";
import ServiceFactory from "../../framework/factory/ServiceFactory";

export class OrderWeeeDataService extends WeeeDataService {
    static className = 'OrderWeeeDataService';

    /**
     * Get applied items
     * @param item
     * @param order
     * @return {*}
     */
    getApplied(item, order) {
        let data = item.weee_tax_applied;
        if (!data) {
            return [];
        }
        return JSON.parse(data);
    }
}

/** @type OrderWeeeDataService */
let orderWeeeDataService = ServiceFactory.get(OrderWeeeDataService);

export default orderWeeeDataService;


// WEBPACK FOOTER //
// ./src/service/weee/OrderWeeeDataService.js